import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { GET } from 'utils/request';
import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import {
  FILTER_DEFAULT_LIMIT,
  REQUEST_TRANSPORTERS,
  APPLY_TRANSPORTER_FILTERS,
  REQUEST_TRANSPORTER_FILTER,
  REQUEST_TRANSPORTER_FILTER_RESET,
} from './constants';
import { selectTransporterFilter } from './selectors';

function* requestTransporterFilter() {
  let filter = yield select(selectTransporterFilter());
  console.log('Filters to send: ', filter);
  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString?.trim() || null;
  const sortType = filter?.sortType;
  const order = filter?.order;

  let path = `transporters/getList`;

  let searchParams = {
    offset,
    limit,
    text: text ?? undefined,
    filters: filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f)),
  };

  if (!!sortType) {
    searchParams.sortType = sortType;
    searchParams.order = order ?? 'desc';
  }

  yield put({
    type: GET_MY,
    id: REQUEST_TRANSPORTERS,
    work: REQUEST_TRANSPORTERS,
    gate: REQUEST_TRANSPORTERS,
    path,
    post: searchParams,
  });
}

export function* transporterSaga() {
  yield all([
    takeEvery(APPLY_TRANSPORTER_FILTERS, requestTransporterFilter),
    takeEvery(REQUEST_TRANSPORTER_FILTER, requestTransporterFilter),
    takeEvery(REQUEST_TRANSPORTER_FILTER_RESET, requestTransporterFilter),
  ]);
}
